import {ButtonV2Variant} from '../../atoms/ButtonV2/ButtonV2.enum';
import {Dialog} from '../Dialog';
import {RedeemDialogProps} from './RedeemDialogProps.interface';

export function RedeemDialog({
  isMobile,
  showDialog,
  dialog,
  onClickSecondButton,
  onClickActiveButton,
  closeDialog,
}: RedeemDialogProps) {
  return (
    <Dialog isOpen={showDialog} isMobile={isMobile} onClose={closeDialog}>
      <Dialog.Dimmed />
      <Dialog.Title>{dialog?.title}</Dialog.Title>
      {dialog?.description && (
        <Dialog.List>
          <Dialog.Label>{dialog.description}</Dialog.Label>
        </Dialog.List>
      )}
      <Dialog.BottomCombination>
        {dialog?.secondButton && (
          <Dialog.Button onClick={onClickSecondButton}>
            {dialog.secondButton}
          </Dialog.Button>
        )}
        {dialog?.activeButton && (
          <Dialog.Button
            onClick={onClickActiveButton}
            variant={
              dialog?.secondButton
                ? ButtonV2Variant.Primary
                : ButtonV2Variant.Secondary
            }
          >
            {dialog.activeButton}
          </Dialog.Button>
        )}
      </Dialog.BottomCombination>
    </Dialog>
  );
}
